import axios from "../../../config/axiosConfig";

const base = "/api/catalogo-equipos";

export const getCatalogos = () => axios.get(`${base}/catalogos`);

export const listarServicios = () => axios.get(`${base}/servicios`);
export const crearServicio = (body) => axios.post(`${base}/servicios`, body);

export const listarTiposEquipo = (params) => axios.get(`${base}/tipos-equipo`, { params });
export const crearTipoEquipo = (body) => axios.post(`${base}/tipos-equipo`, body);

export const listarTiposModelo = (params) => axios.get(`${base}/tipos-modelo`, { params });
export const crearTipoModelo = (body) => axios.post(`${base}/tipos-modelo`, body);
export const getTipoModelo = (id) => axios.get(`${base}/tipos-modelo/${id}`);
export const crearModelo = (idTipoModelo, body) => axios.post(`${base}/tipos-modelo/${idTipoModelo}/modelos`, body);

export const eliminarTipoEquipo = (params) => axios.delete(`${base}/tipos-equipo`, { params });
export const eliminarTipoModelo = (id) => axios.delete(`${base}/tipos-modelo/${id}`);
export const listarEquiposDeModelo = (id, params) => axios.get(`${base}/modelos/${id}/equipos`, { params });
export const eliminarModelo = (id) => axios.delete(`${base}/modelos/${id}`);

export const listarFallas = (params) => axios.get(`${base}/fallas`, { params });
export const crearFalla = (body) => axios.post(`${base}/fallas`, body);

export const mensajeError = (e, defecto) => e?.response?.data?.error || defecto;
